import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity MembersGroupUsers


export interface MembersGroupUser {
    id: ID;

    
    membersGroupId: ID;

    
    ownedMembersGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            membersGroupId: ID[],
        
    
    

            ownedMembersGroupId: ID[],
        
    
    



        membersGroupIdRefs?: ID[],
        ownedMembersGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateMembersGroupUser {
    
    membersGroupId: ID;

    
    ownedMembersGroupId: ID;

    }





export class PrimaryMembersGroupUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: MembersGroupUser): PrimaryMembersGroupUser | undefined {
        return entity ? new PrimaryMembersGroupUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryMembersGroupUser {
        return new PrimaryMembersGroupUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryMembersGroupUser {
        let vals = path?.split('/');
        return new PrimaryMembersGroupUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryMembersGroupUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: MembersGroupUser): string {
    let fields = entity ? [
    entity.membersGroupId,
            entity.ownedMembersGroupId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


